const STYLES_ID = 'data-remarq-styles'

const CSS = `
[data-remarq-theme="light"] {
  --remarq-bg: #ffffff;
  --remarq-bg-secondary: #f5f5f5;
  --remarq-text: #1a1a1a;
  --remarq-text-secondary: #666666;
  --remarq-border: #e2e8f0;
  --remarq-accent: #3b82f6;
  --remarq-pending: #f97316;
  --remarq-resolved: #22c55e;
  --remarq-overlay: rgba(59, 130, 246, 0.15);
  --remarq-shadow: 0 4px 12px rgba(0,0,0,0.15);
  --remarq-status-pending: #f97316;
  --remarq-status-in-progress: #eab308;
  --remarq-status-fixed-unverified: #3b82f6;
  --remarq-status-verified: #22c55e;
  --remarq-status-dismissed: #6b7280;
}

[data-remarq-theme="dark"] {
  --remarq-bg: #1e1e1e;
  --remarq-bg-secondary: #2a2a2a;
  --remarq-text: #e5e5e5;
  --remarq-text-secondary: #999999;
  --remarq-border: #333333;
  --remarq-accent: #60a5fa;
  --remarq-pending: #fb923c;
  --remarq-resolved: #4ade80;
  --remarq-overlay: rgba(96, 165, 250, 0.15);
  --remarq-shadow: 0 4px 12px rgba(0,0,0,0.4);
  --remarq-status-pending: #fb923c;
  --remarq-status-in-progress: #facc15;
  --remarq-status-fixed-unverified: #60a5fa;
  --remarq-status-verified: #4ade80;
  --remarq-status-dismissed: #9ca3af;
}

.remarq-toolbar {
  position: fixed;
  z-index: 2147483647;
  display: flex;
  gap: 4px;
  padding: 8px;
  background: var(--remarq-bg);
  border: 1px solid var(--remarq-border);
  border-radius: 8px;
  box-shadow: var(--remarq-shadow);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 13px;
  color: var(--remarq-text);
}

.remarq-toolbar.remarq-pos-bottom-right { bottom: 16px; right: 16px; }
.remarq-toolbar.remarq-pos-bottom-left { bottom: 16px; left: 16px; flex-direction: row-reverse; }
.remarq-toolbar.remarq-pos-top-right { top: 16px; right: 16px; }
.remarq-toolbar.remarq-pos-top-left { top: 16px; left: 16px; flex-direction: row-reverse; }

.remarq-toolbar.remarq-minimized { padding: 8px; }

.remarq-toolbar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--remarq-text);
  cursor: pointer;
  position: relative;
}

.remarq-toolbar-btn:hover { background: var(--remarq-bg-secondary); }
.remarq-toolbar-btn.remarq-active { background: var(--remarq-accent); color: #ffffff; }

.remarq-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  padding: 0;
  border-radius: 50%;
  background: var(--remarq-pending);
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.remarq-toolbar-badge--verification {
  top: auto;
  bottom: -6px;
  right: -6px;
  background: var(--remarq-status-fixed-unverified);
  cursor: pointer;
}

.remarq-overlay {
  position: fixed;
  pointer-events: none;
  background: var(--remarq-overlay);
  border: 2px solid var(--remarq-accent);
  border-radius: 2px;
  z-index: 2147483646;
  transition: all 0.05s ease-out;
}

.remarq-tooltip {
  position: fixed;
  z-index: 2147483647;
  padding: 4px 8px;
  background: var(--remarq-bg);
  border: 1px solid var(--remarq-border);
  border-radius: 4px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 12px;
  color: var(--remarq-text);
  box-shadow: var(--remarq-shadow);
  pointer-events: none;
  white-space: nowrap;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.remarq-marker {
  position: absolute;
  z-index: 2147483645;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  transition: transform 0.1s ease;
}

.remarq-marker:hover { transform: scale(1.2); }
.remarq-marker--pending { background: var(--remarq-status-pending); }
.remarq-marker--in-progress { background: var(--remarq-status-in-progress); }
.remarq-marker--fixed-unverified { background: var(--remarq-status-fixed-unverified); }
.remarq-marker--verified { background: var(--remarq-status-verified); opacity: 0.7; }
.remarq-marker--dismissed { background: var(--remarq-status-dismissed); opacity: 0.5; }

.remarq-popup {
  position: absolute;
  z-index: 2147483647;
  width: 300px;
  background: var(--remarq-bg);
  border: 1px solid var(--remarq-border);
  border-radius: 8px;
  box-shadow: var(--remarq-shadow);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 13px;
  color: var(--remarq-text);
}

.remarq-popup-header {
  padding: 8px 12px;
  border-bottom: 1px solid var(--remarq-border);
  font-size: 12px;
  color: var(--remarq-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remarq-popup-body { padding: 12px; }

.remarq-popup textarea {
  width: 100%;
  min-height: 60px;
  padding: 8px;
  border: 1px solid var(--remarq-border);
  border-radius: 4px;
  background: var(--remarq-bg-secondary);
  color: var(--remarq-text);
  font-family: inherit;
  font-size: 13px;
  resize: vertical;
  box-sizing: border-box;
}

.remarq-popup textarea:focus { outline: none; border-color: var(--remarq-accent); }

.remarq-popup-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 12px;
  border-top: 1px solid var(--remarq-border);
}

.remarq-popup-actions-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.remarq-popup-actions-row--transitions {
  justify-content: flex-start;
}

.remarq-popup-actions-row--utility {
  justify-content: flex-end;
  padding-top: 6px;
  border-top: 1px dashed var(--remarq-border);
}

.remarq-popup-actions button {
  padding: 5px 12px;
  border: 1px solid var(--remarq-border);
  border-radius: 4px;
  background: var(--remarq-bg);
  color: var(--remarq-text);
  cursor: pointer;
  font-size: 12px;
}

.remarq-popup-actions button.remarq-primary {
  background: var(--remarq-accent);
  border-color: var(--remarq-accent);
  color: #ffffff;
}

.remarq-popup-utility-btn {
  font-size: 11px !important;
  padding: 3px 10px !important;
  color: var(--remarq-text-secondary) !important;
  background: transparent !important;
  border-color: transparent !important;
}

.remarq-popup-utility-btn:hover {
  background: var(--remarq-bg-secondary) !important;
  color: var(--remarq-text) !important;
}

.remarq-detached-panel {
  position: fixed;
  z-index: 2147483646;
  width: 280px;
  max-height: 300px;
  overflow-y: auto;
  background: var(--remarq-bg);
  border: 1px solid var(--remarq-border);
  border-radius: 8px;
  box-shadow: var(--remarq-shadow);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 13px;
  color: var(--remarq-text);
}

.remarq-detached-panel.remarq-pos-bottom-right { bottom: 60px; right: 16px; }
.remarq-detached-panel.remarq-pos-bottom-left { bottom: 60px; left: 16px; }
.remarq-detached-panel.remarq-pos-top-right { top: 60px; right: 16px; }
.remarq-detached-panel.remarq-pos-top-left { top: 60px; left: 16px; }

.remarq-detached-header {
  padding: 8px 12px;
  border-bottom: 1px solid var(--remarq-border);
  font-weight: 600;
  font-size: 12px;
  color: var(--remarq-text-secondary);
}

.remarq-detached-item {
  padding: 8px 12px;
  border-bottom: 1px solid var(--remarq-border);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}

.remarq-detached-item:last-child { border-bottom: none; }
.remarq-detached-info { flex: 1; min-width: 0; }
.remarq-detached-comment { margin-bottom: 4px; }

.remarq-detached-element {
  font-size: 11px;
  color: var(--remarq-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remarq-detached-delete {
  border: none;
  background: none;
  color: var(--remarq-text-secondary);
  cursor: pointer;
  padding: 2px;
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.remarq-detached-delete:hover { color: #ef4444; }

.remarq-export-menu {
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-bottom: 4px;
  background: var(--remarq-bg);
  border: 1px solid var(--remarq-border);
  border-radius: 6px;
  box-shadow: var(--remarq-shadow);
  overflow: hidden;
}

.remarq-pos-top-right .remarq-export-menu,
.remarq-pos-top-left .remarq-export-menu {
  bottom: auto;
  top: 100%;
  margin-bottom: 0;
  margin-top: 4px;
}

.remarq-pos-bottom-left .remarq-export-menu,
.remarq-pos-top-left .remarq-export-menu {
  right: auto;
  left: 0;
}

.remarq-export-menu button {
  display: block;
  width: 100%;
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: var(--remarq-text);
  cursor: pointer;
  font-size: 12px;
  text-align: left;
  white-space: nowrap;
}

.remarq-export-menu button:hover { background: var(--remarq-bg-secondary); }

.remarq-detached-header + .remarq-detached-header {
  border-top: 2px solid var(--remarq-border);
}

.remarq-detached-item[style*="cursor"]:hover {
  background: var(--remarq-bg-secondary);
}

.remarq-toast {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2147483647;
  padding: 8px 16px;
  background: var(--remarq-bg);
  border: 1px solid var(--remarq-border);
  border-radius: 6px;
  box-shadow: var(--remarq-shadow);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 13px;
  color: var(--remarq-text);
  transition: opacity 0.3s ease;
}

.remarq-toast-fade {
  opacity: 0;
}

.remarq-spacing {
  position: fixed;
  pointer-events: none;
  z-index: 2147483646;
}

.remarq-spacing-margin {
  position: absolute;
  background: rgba(249, 115, 22, 0.2);
  pointer-events: none;
  z-index: 1;
}

.remarq-spacing-padding {
  position: absolute;
  background: rgba(34, 197, 94, 0.2);
  pointer-events: none;
  z-index: 2;
}

.remarq-spacing-content {
  position: absolute;
  background: rgba(59, 130, 246, 0.3);
  border: 1px dashed rgba(96, 165, 250, 0.8);
  pointer-events: none;
  z-index: 3;
}

.remarq-spacing-gap {
  position: fixed;
  background: rgba(168, 85, 247, 0.25);
  border: 1px dashed rgba(168, 85, 247, 0.5);
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remarq-spacing-label {
  position: absolute;
  font-size: 11px;
  font-weight: 700;
  pointer-events: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1;
  padding: 1px 3px;
  border-radius: 2px;
}

.remarq-spacing-label-margin { color: #fff; background: rgba(249, 115, 22, 0.85); }
.remarq-spacing-label-padding { color: #fff; background: rgba(34, 197, 94, 0.85); }
.remarq-spacing-label-content { color: #fff; background: rgba(59, 130, 246, 0.85); font-size: 10px; }
.remarq-spacing-label-gap { color: #fff; background: rgba(168, 85, 247, 0.85); font-size: 10px; }

.remarq-toolbar-btn:disabled { opacity: 0.3; cursor: default; }
.remarq-toolbar-btn:disabled:hover { background: transparent; }

.remarq-shortcuts-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remarq-shortcuts-modal {
  background: var(--remarq-bg);
  border: 1px solid var(--remarq-border);
  border-radius: 12px;
  box-shadow: var(--remarq-shadow);
  padding: 20px 24px;
  min-width: 300px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: var(--remarq-text);
}

.remarq-shortcuts-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--remarq-border);
}

.remarq-shortcuts-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
  font-size: 13px;
}

.remarq-shortcuts-key {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  padding: 2px 8px;
  background: var(--remarq-bg-secondary);
  border: 1px solid var(--remarq-border);
  border-radius: 4px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.remarq-shortcuts-context {
  font-size: 10px;
  color: var(--remarq-text-secondary);
  background: var(--remarq-bg-secondary);
  border-radius: 3px;
  padding: 1px 6px;
  margin-left: auto;
}

.remarq-popup-hint {
  font-size: 11px;
  color: var(--remarq-text-secondary);
  margin-top: 4px;
}

.remarq-popup-history {
  margin-top: 8px;
  font-size: 12px;
  color: var(--remarq-text-secondary);
}

.remarq-popup-history summary {
  cursor: pointer;
  padding: 4px 0;
  user-select: none;
}

.remarq-popup-history-list {
  list-style: none;
  margin: 4px 0 0 0;
  padding: 0;
}

.remarq-popup-history-list li {
  padding: 2px 0;
  font-size: 11px;
  line-height: 1.4;
}

.remarq-popup-reason {
  width: 100%;
  min-height: 50px;
  margin-bottom: 8px;
  padding: 6px;
  border: 1px solid var(--remarq-border);
  border-radius: 4px;
  background: var(--remarq-bg-secondary);
  color: var(--remarq-text);
  font-family: inherit;
  font-size: 12px;
  resize: vertical;
  box-sizing: border-box;
}

.remarq-popup-reason-row {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
`

export function injectStyles(): void {
  if (document.querySelector(`style[${STYLES_ID}]`)) return

  try {
    const style = document.createElement('style')
    style.setAttribute(STYLES_ID, '')
    style.textContent = CSS
    document.head.appendChild(style)
  } catch {
    // CSP fallback: try blob URL via <link>
    try {
      const blob = new Blob([CSS], { type: 'text/css' })
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = URL.createObjectURL(blob)
      link.setAttribute(STYLES_ID, '')
      document.head.appendChild(link)
    } catch {
      console.warn('[web-remarq] Could not inject styles')
    }
  }
}

export function removeStyles(): void {
  const el = document.querySelector(`[${STYLES_ID}]`)
  el?.remove()
}
